import { AfterViewInit, Component, EventEmitter, Output } from '@angular/core';

import { IntervenantsFilters } from '../entities/intervenants-filters.entity';

@Component({
	selector: 'intervenants-filters',
	templateUrl: 'intervenants-filters.html',
	styleUrls: ['intervenants-filters.css']
})
export class IntervenantsFiltersComponent implements AfterViewInit {
	// Valeurs des filtres choisis par l'utilisateur
	filters: IntervenantsFilters = new IntervenantsFilters();

	// Evenement pour quand l'utilisateur demande l'application des filtres
	@Output() filterRequest = new EventEmitter<IntervenantsFilters>();

	constructor(
	) {
	}
	
	ngAfterViewInit() {
		this.applyFilters();
	}

	applyFilters() {
		this.filterRequest.emit(this.filters);
	}

	resetFilters() {
		this.filters =  new IntervenantsFilters(); 
		this.applyFilters();
	}
}